import { render } from "./Leftbar.vue?vue&type=template&id=862e2950"
import script from "./Leftbar.vue?vue&type=script&lang=js"
export * from "./Leftbar.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__